import { createNavigation } from "next-intl/navigation";

import { routing } from "./routing";

// Locale-aware wrappers around Next.js navigation:
//   - links and router calls keep the current locale prefix
//   - `usePathname` returns the path without it.
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing);
